import { useEffect, useMemo, useState } from "react";
import { Loader2 } from "lucide-react";

import "./styles/login-premium.css";
import LoginPage from "./pages/LoginPage";
import MainApp from "./pages/MainApp";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import { useAuth } from "./hooks/useAuth";
import {
  ouvirBilling,
  prepararUsuarioNovo,
} from "./services/financeService";

function billingLiberado(billing) {
  if (!billing) return false;

  const agora = Date.now();

  const trialEndsAt = billing?.trialEndsAt?.toDate?.()?.getTime?.() || 0;
  const accessExpiresAt = billing?.accessExpiresAt?.toDate?.()?.getTime?.() || 0;

  const trialValido =
    billing?.status === "trialing" &&
    trialEndsAt > agora;

  const assinaturaValida =
    billing?.status === "active" &&
    billing?.assinaturaAtiva === true &&
    billing?.paymentApproved === true &&
    accessExpiresAt > agora;

  return trialValido || assinaturaValida;
}

export default function App() {
  const { usuario, carregandoAuth } = useAuth();

  const [billing, setBilling] = useState(null);
  const [carregandoBilling, setCarregandoBilling] = useState(true);

  useEffect(() => {
    if (!usuario?.uid) {
      setBilling(null);
      setCarregandoBilling(false);
      return;
    }

    setCarregandoBilling(true);

    prepararUsuarioNovo(
      usuario.uid,
      usuario.displayName || "Invexa",
      usuario.email || ""
    ).catch(console.error);

    const unsubscribe = ouvirBilling(usuario.uid, (dados) => {
      setBilling(dados || null);
      setCarregandoBilling(false);
    });

    return () => unsubscribe();
  }, [usuario]);

  const liberado = useMemo(() => billingLiberado(billing), [billing]);

  if (window.location.pathname === "/privacy") {
    return <PrivacyPolicy />;
  }

  if (carregandoAuth || carregandoBilling) {
    return (
      <div className="loading-screen">
        <Loader2 className="spin" size={34} />
        <p>Carregando Invexa Finance...</p>
      </div>
    );
  }

  if (!usuario) return <LoginPage />;

  return (
    <MainApp
      usuario={usuario}
      billing={billing}
      liberado={liberado}
    />
  );
}